import glamorous from 'glamorous';
import { mediaQueries } from '../constants/mediaqueries.const';

export const MainWrapper = glamorous.div('ncss-container u-full-height', {
  backgroundColor: '#FFF',
  padding: 0,
  [mediaQueries.tablet]: {
    backgroundColor: '#FFF',
  },
  [mediaQueries.desktop]: {
    backgroundColor: '#FFF',
  },
});
MainWrapper.displayName = 'MainWrapper';

export const ContentWrapper = glamorous.div('ncss-container u-full-height', {
  padding: '0 0 0 0',
  [mediaQueries.tablet]: {},
  [mediaQueries.desktop]: {},
});
ContentWrapper.displayName = 'ContentWrapper';



// WEBPACK FOOTER //
// ./src/containers/App.style.js